/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-12-04 14:21:40
 *
 *******************************************************/
//flow
import _ from 'lodash';
import React, { Component } from 'react';
import { Modal, Stack, ButtonGroup, Button } from '@shopify/polaris';
import { withI18n } from '@shopify/react-i18n';
import { MENU_ID } from 'src/constants/theme-settings.jsx';
import { reorderTwoList } from 'src/helpers';
import { TYPE_UPDATE_SETTING } from 'src/constants/theme-settings';

type State = {};

type Props = {};

class MovingElementModal extends Component<Props, State> {
  state = {};

  area = {
    [MENU_ID.PRODUCT_IMAGE_TOP]: 'AdminHTML.ThemeSetting.MovingElementModal.topArea',
    [MENU_ID.PRODUCT_IMAGE_MIDDLE]: 'AdminHTML.ThemeSetting.MovingElementModal.middleArea',
    [MENU_ID.PRODUCT_IMAGE_BOTTOM]: 'AdminHTML.ThemeSetting.MovingElementModal.bottomArea'
  };

  componentDidMount() {}

  handleMove = () => {
    const {
      onClose,
      updateField,
      handleChangeActiveMenuItem,
      handleUpdateMenuSetting,
      menus,
      movingElementInfo,
      formValues,
      activeMenuItem
    } = this.props;

    let fromAreaPath = _.get(movingElementInfo, 'from.value', '');
    const [prefix, elementName] = fromAreaPath.split('_');
    const fromArea = `${prefix}_setting`;
    const toArea = _.get(movingElementInfo, 'to', '');

    const sourceChildren = menus.find(item => item.id === fromArea)?.children || [];
    const destChildren = menus.find(item => item.id === toArea)?.children || [];

    const childIndex = sourceChildren.findIndex(item => {
      return item?.value?.includes(elementName);
    });
    const child = sourceChildren[childIndex];

    const originalData = _.get(formValues, child.value, null);
    const isSelecting = activeMenuItem === child.value;
    updateField(child.value, ''); // Remove data setting of old place

    const [destElementId] = toArea.split('_');
    child.value = `${destElementId}_${elementName}`;

    const [sourceResult, destResult] = reorderTwoList(
      sourceChildren,
      destChildren,
      childIndex,
      destChildren.length // Insert at the end of area
    );

    // Update data setting of new place
    updateField(child.value, originalData);
    // Update position in redux form
    sourceResult.forEach((elem, index) => {
      updateField(`${elem.value}.position`, index);
    });
    destResult.forEach((elem, index) => {
      updateField(`${elem.value}.position`, index);
    });

    // If that menu item is selecting, trigger select with new prefix to re-render form on the right panel
    if (isSelecting) {
      handleChangeActiveMenuItem(child.value, TYPE_UPDATE_SETTING.COMMON);
    }

    handleUpdateMenuSetting(fromArea, sourceResult, TYPE_UPDATE_SETTING.COMMON);
    handleUpdateMenuSetting(toArea, destResult, TYPE_UPDATE_SETTING.COMMON);
    onClose();
  };

  handleCloseModal = () => {
    const { onClose } = this.props;
    onClose();
    // updateFieldReducer('movingInfoProductImage', null);
  };

  render() {
    const { i18n, active, movingElementInfo } = this.props;
    if (_.isEmpty(movingElementInfo)) {
      return null;
    }

    const fromAreaPath = _.get(movingElementInfo, 'from.value', '');
    const [preffix] = fromAreaPath.split('_');
    const fromArea = i18n.translate(this.area[`${preffix}_setting`]);
    const toArea = i18n.translate(this.area[_.get(movingElementInfo, 'to', '')]);
    const element = i18n.translate(_.get(movingElementInfo, 'element.label', ''));

    return (
      <Modal
        open={active}
        onClose={this.handleCloseModal}
        title={i18n.translate('AdminHTML.ThemeSetting.MovingElementModal.title')}
        footer={
          <div className="modal-footer-moving-element">
            <Stack distribution="trailing" alignment="center">
              <Stack.Item>
                <div className="Polaris-Stack__Item--custom">
                  <ButtonGroup>
                    <Button onClick={this.handleCloseModal}>
                      {i18n.translate('AdminHTML.Common.Action.cancel')}
                    </Button>
                    <Button onClick={this.handleMove} primary>
                      {i18n.translate('AdminHTML.ThemeSetting.MovingElementModal.move')}
                    </Button>
                  </ButtonGroup>
                </div>
              </Stack.Item>
            </Stack>
          </div>
        }>
        <Modal.Section>
          <div className="modal-content-moving-element">
            <p>
              {i18n.translate('AdminHTML.ThemeSetting.MovingElementModal.content', {
                the: <b>{i18n.translate('AdminHTML.ThemeSetting.MovingElementModal.the')}</b>,
                element: <b style={{ textTransform: 'lowercase' }}>{element}</b>,
                fromArea: <b>{fromArea}</b>,
                toArea: <b>{toArea}</b>
              })}
            </p>
          </div>
        </Modal.Section>
      </Modal>
    );
  }
}

export default withI18n()(MovingElementModal);
